<template>
  <div class="add">
    <div class="title">
      <a-icon class="btn_back" theme="twoTone" type="left-circle" @click="$router.go(-1)" />
      <h2 class="name">售客/{{ formTitle }}</h2>
    </div>

    <div class="content">
      <!-- 核心信息 -->
      <MainInfo
        ref="ruleForm"
        :form="form"
        :rules="rules"
        :sexOptions="sexOptions"
        @addPhone="addPhone"
        @searchBtn="searchBtn" />
      <!-- <a-form-model ref="ruleForm" :model="form.lesseeInfoBo" :rules="rules" v-if="false">
        <h3 class="label">核心信息</h3>
        <a-row>
          <a-col class="mr30" :span="4">
            <a-form-model-item label="客户姓名" prop="lesseeName" :colon="false">
              <a-input placeholder="客户姓名" v-model="form.lesseeInfoBo.lesseeName" :maxLength="16" />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="客户电话" prop="lesseePhone" :colon="false">
              <a-input
                :maxLength="11"
                placeholder="客户电话"
                v-model="form.lesseeInfoBo.lesseePhone"
                @blur="searchBtn(form.lesseeInfoBo.lesseePhone)"
              />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="微信" :colon="false">
              <a-input placeholder="微信" v-model="form.lesseeInfoBo.lesseeWechat" :maxLength="11" />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="性别" :colon="false">
              <a-select placeholder="请选择" v-model="form.lesseeInfoBo.lesseeSex">
                <a-select-option v-for="item in sexOptions" :value="item.dictValue" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label=" " :colon="false">
              <a-button @click="isAlternatePhone = true">+添加备用电话</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model> -->

      <!-- 备用电话 -->
      <a-form-model v-if="isAlternatePhone" :model="alternatePhone" :rules="rules">
        <a-row>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话一" prop="phone1">
              <a-input v-model="alternatePhone.phone1" :maxLength="11" placeholder="备用电话一" @blur="searchBtn(alternatePhone.phone1)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话二" prop="phone2">
              <a-input v-model="alternatePhone.phone2" :maxLength="11" placeholder="备用电话二" @blur="searchBtn(alternatePhone.phone2)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话三" prop="phone3">
              <a-input v-model="alternatePhone.phone3" :maxLength="11" placeholder="备用电话三" @blur="searchBtn(alternatePhone.phone3)" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <a-divider />

      <!-- 需求信息 -->
      <a-form-model ref="ruleForm2" :model="form" :rules="rules">
        <h3 class="label">需求信息</h3>

        <a-row style="margin-top: 20px">
          <a-col :span="4" class="mr30" style="display: flex">
            <a-form-model-item :colon="false" label="最低价格" prop="requirementPriceStart">
              <a-input
                v-model="form.requirementPriceStart"
                :maxLength="10"
                placeholder="最低价格"
                suffix="万"
                @input="intValidate('requirementPriceStart')"
              />
            </a-form-model-item>
            <a-form-model-item :colon="false" label="最高价格" prop="requirementPriceEnd">
              <a-input
                v-model="form.requirementPriceEnd"
                :maxLength="10"
                placeholder="最高价格"
                suffix="万"
                @input="intValidate('requirementPriceEnd')"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="区域">
              <a-select v-model="form.districtName" placeholder="区域" @change="regionChange($event, 'addSaleTourist')">
                <a-select-option v-for="item in region" :key="item.areaId" :value="item.areaId">
                  {{ item.areaName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="商圈">
              <a-select
                v-model="form.businessDistrictId"
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                :show-arrow="true"
                placeholder="商圈"
                show-search
                @change="businessDistrictMethod($event, 'addSaleTourist')"
                @search="businessDisSearch"
              >
                <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.id">{{ item.businessDistrictName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="街道">
              <a-select
                v-model="form.streetId"
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                :show-arrow="true"
                placeholder="街道"
                show-search
                @change="StreetMethod($event, 'addSaleTourist')"
                @search="streetSearch"
              >
                <a-select-option v-for="item in StreetData" :key="item.id" :value="item.id">{{ item.streetFullName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="等级">
              <a-select v-model="form.requirementLevel" defaultValue="" placeholder="全部">
                <a-select-option key="requirementLevel0" value="">全部</a-select-option>
                <a-select-option v-for="item in requirement_level_list" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="付款方式">
              <a-select v-model="form.paymentType" defaultValue="" placeholder="全部">
                <a-select-option key="paymentType0" value="">全部</a-select-option>
                <a-select-option v-for="item in payment_method_list" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="客户类型">
              <a-select v-model="form.customerType" defaultValue="" placeholder="全部">
                <a-select-option key="customerType0" value="">全部</a-select-option>
                <a-select-option v-for="item in customer_type_list" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="投资类型">
              <a-select v-model="form.investmentType" defaultValue="" placeholder="全部">
                <a-select-option key="investmentType0" value="">全部</a-select-option>
                <a-select-option v-for="item in investment_type_list" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <!-- <a-row>
          <a-col class="mr30" :span="4">
            <a-form-model-item label="经营行业" :colon="false">
              <span style="display: flex; margin-top: 4px">
                <a-select
                  style="margin-right: 3px"
                  v-model="form.industryCategoryId"
                  placeholder="行业"
                  @change="getIndustryCategoryName"
                >
                  <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">{{
                    item.industryCategoryName
                  }}</a-select-option>
                </a-select>
                <a-select v-model="form.industrySubclassId" placeholder="子类" @change="getIndustrySubclassName">
                  <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">{{
                    item.industryCategoryName
                  }}</a-select-option>
                </a-select>
              </span>
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="需求商铺类型" :colon="false">
              <a-select placeholder="请选择" v-model="form.storeTypeId">
                <a-select-option :value="item.dictValue" v-for="item in typeOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="经营状态" :colon="false">
              <a-select placeholder="请选择" v-model="form.operatingStateId">
                <a-select-option :value="item.dictValue" v-for="item in statusOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item></a-col
          >
        </a-row> -->

        <a-row style="margin-top: 20px">
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="是否有投资其他房源">
              <a-select v-model="form.isInvestmentOtherHouse" defaultValue="" placeholder="全部">
                <a-select-option key="investmentType0" value="">全部</a-select-option>
                <a-select-option v-for="item in isOptions" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="商铺性质">
              <a-select v-model="form.shopNatureId" defaultValue="" placeholder="全部">
                <a-select-option key="shopNatureId0" value="">全部</a-select-option>
                <a-select-option v-for="item in natureOptions" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item :colon="false" label="商铺配套">
          <a-checkbox-group v-model="shopAncillaryArr">
            <a-checkbox v-for="item in shopAncillaryOpts" :key="item.dictValue" :value="item.dictLabel" style="margin-bottom: 20px">
              {{ item.dictLabel }}
            </a-checkbox>
          </a-checkbox-group>
          <!-- <div>
            <span style="position: relative">
              <label for="" style="margin-left: 20px">气量</label
              ><input
                style="
                  width: 60px;
                  border: 1px solid #d9d9d9;
                  outline: none;
                  height: 16px;
                  margin-right: 20px;
                  margin-left: 10px;
                  line-height: 19px;
                "
                v-model="form.gasCapacity"
                @input="intValidate('gasCapacity')"
                suffix="m³"
              /><span style="position: absolute; top: -10px; right: 0">m³</span>
            </span>
            <span style="position: relative">
              <label for="" style="margin-left: 20px">电功率</label
              ><input
                style="
                  width: 60px;
                  border: 1px solid #d9d9d9;
                  outline: none;
                  height: 16px;
                  margin-right: 20px;
                  margin-left: 10px;
                  line-height: 19px;
                "
                v-model="form.electricPower"
                @input="intValidate('electricPower')"
                suffix="kw"
              /><span style="position: absolute; top: -10px; right: 0">kw</span>
            </span>
          </div> -->
        </a-form-model-item>

        <a-form-model-item label="消费配套">
          <a-checkbox-group v-model="form.consumeAncillaryIds" @change="consumeAncillaryChange">
            <a-checkbox v-for="item in consumeAncillaryOpts" :key="item.dictValue" :value="item.dictValue">
              {{ item.dictLabel }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>

        <a-form-model-item :colon="false" label="自定义标签">
          <a-checkbox-group v-model="customTags">
            <a-checkbox v-for="item in customTagList" :key="item.id" :value="item.tagName" name="type">
              {{ item.tagName }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>

        <a-divider />
        <h3 class="label">其他信息</h3>
        <textarea v-model="form.otherInfo" class="textarea" placeholder="请输入备注信息"></textarea>
      </a-form-model>
    </div>
    <div style="text-align: center; margin-bottom: 100px">
      <a-button :disabled="isExists" class="el_button el-button--primary touristBtn" size="large" @click="addtourist">
        {{ this.$route.query.id >= 0 ? '保存' : '提交' }}
      </a-button>
    </div>
    <a-modal v-model="phoneRepeatVisible" :footer="null" on-ok="handleOk" title="温馨提示">
      <p class="">
        我的客源已经存在该号码：
        <a @click="goTouristDetail()">{{ curRepeatPhone }}</a>
        ,请前往查看!!!
      </p>
    </a-modal>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js'
import { singleSelectMixin } from '@/mixin/singleSelect'
import sell_touristApi from '@/api/system/tourist/sell_tourist.js'
import MainInfo from './components/addForm/mainInfo.vue'
import beforeRouteLeaveMixin from '@/mixin/beforeRouteLeave'

export default {
  name: 'TouristSellAdd',
  components: { MainInfo },
  mixins: [singleSelectMixin, beforeRouteLeaveMixin],
  data () {
    // 电话号码正则
    const validatePhone = async (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value === undefined || value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号码!'))
      } else {
        callback()
      }
    }
    // 数字正则
    const validateNumber = (rule, value, callback) => {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if (value === undefined || value === '' || value === null) {
        callback()
      } else if (!reg.test(value)) {
        console.log(value, '来自数字正则打印')
        callback(new Error('格式不正确！'))
      } else {
        callback()
      }
    }
    return {
      phoneRepeatVisible: false,
      curRepeatLesseeInfoId: '',
      curRepeatPhone: '',
      form: {
        channelResource: '1',
        requirementPriceStart: '',
        requirementPriceEnd: '',
        requirementLevel: undefined,
        paymentType: undefined,
        customerType: undefined,
        investmentType: undefined,
        isInvestmentOtherHouse: undefined,

        alloweCateringTypeId: undefined,
        businessDistrictId: undefined,
        businessDistrictName: undefined,
        districtId: undefined,
        districtName: undefined,
        electricPower: '', // 电功率
        gasCapacity: '', // 天然气容量
        ifEscalator: 'N',
        ifNetwork: 'N',
        industryCategoryName: undefined,
        industrySubclassName: undefined,
        industryCategoryId: undefined, //	行业分类 字典表类型：industry_category
        industrySubclassId: undefined, //	经营行业 字典表类型：industry_subclass
        isCanNakedLight: 'N',
        isEjectSmoke: 'N',
        isElevator: 'N',
        isGas: 'N',
        isOfficePass: 'N',
        isOtherPass: 'N',
        isOutsideArea: 'N',
        isParkingSpace: 'N',
        isPassengerLift: 'N',
        isPower: 'N',
        isResidentsPass: 'N',
        isSewageDisposal: 'N',
        isSewerSystem: 'N',
        isStudentsPass: 'N',
        isTouristPass: 'N',
        isWaterworks: 'N',
        lesseeInfoBo: {
          alternatePhone: '', // 备用手机号（最多三个），逗号隔开
          lesseeName: '',
          lesseePhone: '',
          lesseeSex: undefined,
          lesseeWechat: '',
          id: '',
          rentSaleType: '2'
        },
        operatingStateId: undefined,
        otherInfo: '',
        shopNatureId: undefined,
        storeTypeId: undefined,
        streetId: undefined,
        streetName: undefined,
        customTags: '', // 自定义标签数组
        shopAncillary: '', // 商铺配套名称数组
        consumeAncillaryArr: [],
        consumeAncillaryIds: [], // 消费配套IDs
        consumeAncillary: undefined // 消费配套，多个之间用逗号隔开
      },

      rules: {
        lesseeName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 16, message: '姓名格式不正确', trigger: 'blur' }
        ],
        lesseePhone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        phone1: [{ validator: validatePhone, trigger: 'blur' }],
        phone2: [{ validator: validatePhone, trigger: 'blur' }],
        phone3: [{ validator: validatePhone, trigger: 'blur' }],
        requirementPriceStart: [
          { required: true, message: '开始价格', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        requirementPriceEnd: [
          { required: true, message: '结束价格', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' },
          {
            validator: this.requirementPriceEndRule,
            trigger: 'blur'
          }
        ],
        lesseeSex: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      food: [
        { id: 0, title: '可轻餐' },
        { id: 1, title: '可重餐' }
      ],
      shopAncillaryArr: [], // 商铺配套-被选中
      customTags: [], // 自定义标签-被选中
      alternatePhone: {
        phone1: '',
        phone2: '',
        phone3: ''
      },
      isfood: false,
      isAlternatePhone: false,
      isExists: false,
      isRepeat: false,
      // district: [], // 区域
      businessDistrict: [], // 商圈
      StreetData: [], // 街道
      shopAncillaryOpts: [], // 商铺配套-字典
      consumeAncillaryOpts: [], // 消费配套
      customTagList: [], // 自定义标签-字典

      industryCategory: [], // 行业分类
      industrySubclass: [], // 经营行业（行业子类）

      // 状态数据字典
      requirement_level_list: [],
      payment_method_list: [],
      customer_type_list: [],
      investment_type_list: [],

      isOptions: [],
      sexOptions: [],
      statusOptions: [],
      natureOptions: [],
      typeOptions: [],
      formTitle: '新增客源' // 标题
    }
  },
  methods: {
    // 页面初始化
    init () {
      // 区域列表
      this.getDistrict('addSaleTourist', 'init')
      this.isFromDetails()
      // 查询房源自定义标签列表
      touristApi.houseCustomTagList({ rentSaleType: '2' }).then((res) => {
        if (res.code === 200) {
          this.customTagList = res.data
          // console.log('查询房源自定义标签列表', this.customTagList)
        }
      })

      this.getDICTS()
      this.industryCategoryFn()
    },
    consumeAncillaryChange (val) {
      if (!val) return
      if (val.length > 4) {
        val = val.splice(0, 4)
        this.$message.error('消费配套最多只能选4个，请慎重选择')
      }
      this.form.consumeAncillaryIds = val
      const NAMELIST = []
      const LIST = this.consumeAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictValue) > -1
      })
      for (const obj of LIST) {
        NAMELIST.push(obj.dictLabel)
      }
      this.form.consumeAncillary = NAMELIST.join(',')
      this.$forceUpdate()
    },
    requirementPriceEndRule (rule, value, callback) {
      if (this.form.requirementPriceStart * 1 > this.form.requirementPriceEnd * 1) {
        callback(new Error('最高价格不能小于最低价格'))
      } else {
        callback()
      }
    },
    goTouristDetail () {
      this.$router.push({
        path: '/tourist/sellDetails',
        query: {
          id: this.curRepeatLesseeInfoId
        }
      })
    },

    addPhone () {
      this.isAlternatePhone = true
    },
    // 判断进入页面的路径
    isFromDetails () {
      if (this.$route.query.id >= 0) {
        this.formTitle = '编辑客源'
        this.getDataList()
      } else {
        this.formTitle = '新增客源'
      }
    },
    // 查询客户是否已存在
    async searchBtn (value) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value && !reg.test(value)) return

      const params = {
        alternatePhone: '',
        id: this.form.lesseeInfoBo.id,
        lesseePhone: '',
        rentSaleType: '2'
      }
      this.phone()
      const { lesseePhone, alternatePhone } = this.form.lesseeInfoBo
      if (!lesseePhone && !alternatePhone) {
        this.$message.warning('未填写信息')
      } else if (!lesseePhone) {
        this.$message.warning('未填写电话号码')
      } else {
        params.alternatePhone = alternatePhone
        params.lesseePhone = lesseePhone

        const res = await touristApi.existsSearch(params)
        if (res.code === 200) {
          this.isExists = res.data.isExists
          if (this.isExists) {
            // const touristId = res.data.lesseeInfoId
            // this.$message.warning('手机号码已存在！')
            this.curRepeatPhone = lesseePhone
            this.curRepeatLesseeInfoId = res.data.requirementId // 需求id
            this.phoneRepeatVisible = true

            this.isRepeat = true
          } else {
            this.$message.success('号码有效')
            this.isRepeat = false
          }
        }
      }
    },

    // 返回
    reback () {
      this.$router.go(-1)
    },
    // 获取回显数据
    getDataList () {
      sell_touristApi.touristDetails(Number(this.$route.query.id)).then((res) => {
        if (res.code === 200) {
          // console.log('获取回显数据', res.data)
          // 客户核心信息
          const { id, lesseeName, lesseePhone, lesseeWechat, lesseeSex, alternatePhone } = res.data.lesseeInfoVo
          this.form.lesseeInfoBo.id = id
          this.form.lesseeInfoBo.lesseeName = lesseeName
          this.form.lesseeInfoBo.lesseePhone = lesseePhone
          this.form.lesseeInfoBo.lesseeWechat = lesseeWechat
          this.form.lesseeInfoBo.lesseeSex = lesseeSex || undefined
          if (alternatePhone) {
            this.isAlternatePhone = true
            if (alternatePhone.includes(',')) {
              const phoneList = alternatePhone.split(',')

              if (phoneList.length === 2) {
                this.alternatePhone.phone1 = phoneList[0]
                this.alternatePhone.phone2 = phoneList[1]
                return
              }
              if (phoneList.length === 3) {
                this.alternatePhone.phone1 = phoneList[0]
                this.alternatePhone.phone2 = phoneList[1]
                this.alternatePhone.phone3 = phoneList[2]
              }
            } else {
              this.alternatePhone.phone1 = alternatePhone
            }
          }

          // input框

          this.form.electricPower = res.data.electricPower !== '0.00' ? res.data.electricPower : ''
          this.form.gasCapacity = res.data.gasCapacity !== '0.00' ? res.data.gasCapacity : ''
          this.form.otherInfo = res.data.otherInfo
          this.form.requirementPriceStart = res.data.requirementPriceStart !== '0.00' ? res.data.requirementPriceStart : ''
          this.form.requirementPriceEnd = res.data.requirementPriceEnd !== '0.00' ? res.data.requirementPriceEnd : ''

          // 下拉框
          this.form.requirementLevel = res.data.requirementLevel ? res.data.requirementLevel : undefined
          this.form.paymentType = res.data.paymentType ? res.data.paymentType : undefined
          this.form.customerType = res.data.customerType ? res.data.customerType : undefined
          this.form.investmentType = res.data.investmentType ? res.data.investmentType : undefined
          this.form.isInvestmentOtherHouse = res.data.isInvestmentOtherHouse ? res.data.isInvestmentOtherHouse : undefined

          this.form.industryCategoryName = res.data.industryCategoryName ? res.data.industryCategoryName : undefined
          this.form.industrySubclassName = res.data.industrySubclassName ? res.data.industrySubclassName : undefined
          this.form.industryCategoryId = res.data.industryCategoryId ? res.data.industryCategoryId : undefined
          this.form.industrySubclassId = res.data.industrySubclassId ? res.data.industrySubclassId : undefined
          this.industrySubclassFn(this.form.industryCategoryId)
          this.form.storeTypeId = res.data.storeTypeId ? res.data.storeTypeId.toString() : undefined
          this.form.shopNatureId = res.data.shopNatureId ? res.data.shopNatureId.toString() : undefined
          this.form.operatingStateId = res.data.operatingStateId ? res.data.operatingStateId : undefined
          this.form.alloweCateringTypeId = res.data.alloweCateringTypeId == '3' ? undefined : res.data.alloweCateringTypeId

          this.form.districtName = res.data.districtName ? res.data.districtName : undefined
          this.form.businessDistrictName = res.data.businessDistrictName ? res.data.businessDistrictName : undefined
          this.form.streetName = res.data.streetName ? res.data.streetName : undefined
          this.form.businessDistrictId = res.data.businessDistrictId ? res.data.businessDistrictId : undefined
          this.form.districtId = res.data.districtId ? res.data.districtId : undefined
          this.form.streetId = res.data.streetId ? res.data.streetId : undefined

          // 商铺配套
          this.shopAncillaryArr = res.data.shopAncillary ? res.data.shopAncillary.split(',') : []

          this.form.consumeAncillaryIds = res.data.consumeAncillaryIds || []

          // 自定义标签
          this.customTags = res.data.customTags ? res.data.customTags.split(',') : []

          // 区域列表
          this.getDistrict('addSaleTourist', 'init')
        }
      })
    },

    // 备用电话
    phone () {
      const a = this.alternatePhone.phone1
      const b = this.alternatePhone.phone2
      const c = this.alternatePhone.phone3

      if (a && b && c) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + b + ',' + c
      } else if (a && b) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + b
      } else if (a && c) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + c
      } else if (b && c) {
        this.form.lesseeInfoBo.alternatePhone = b + ',' + c
      } else if (a) {
        this.form.lesseeInfoBo.alternatePhone = a
      } else if (b) {
        this.form.lesseeInfoBo.alternatePhone = b
      } else if (c) {
        this.form.lesseeInfoBo.alternatePhone = c
      } else {
        this.form.lesseeInfoBo.alternatePhone = ''
      }
    },
    // // 获取商圈
    //     getBusDistrict (data) {
    //       touristApi.businessDistrict(data).then((res) => {
    //         if (res.code === 200) {
    //           this.businessDistrict = res.data
    //         }
    //       })
    //     },
    // 客源新增
    async addtourist () {
      // 商铺配套
      this.form.shopAncillary = this.shopAncillaryArr.join(',')

      // 自定义标签
      this.form.customTags = this.customTags.join(',')
      const fromObj = { ...this.form }
      Object.keys(fromObj).forEach((key) => {
        if (fromObj[key] == undefined) {
          fromObj[key] = ''
        }
      })
      if (fromObj.electricPower === '') fromObj.electricPower = 0
      if (fromObj.gasCapacity === '') fromObj.gasCapacity = 0
      if (fromObj.lesseeInfoBo.lesseeSex == undefined) {
        fromObj.lesseeInfoBo.lesseeSex = ''
      }
      const validateFn1 = () => {
        let boolean
        this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
          console.log(valid, 'valid')
          boolean = valid
        })
        return boolean
      }
      const validateFn2 = () => {
        let boolean
        this.$refs.ruleForm2.validate((valid) => {
          boolean = valid
        })
        return boolean
      }
      if (validateFn1() && validateFn2()) {
        if (this.$route.query.id >= 0) {
          fromObj.id = Number(this.$route.query.id)
          fromObj.channelResource = '1'

          sell_touristApi.touristPut(fromObj).then((res) => {
            if (res.code === 200) {
              this.$message.success('修改客源信息成功')
              this.saveType = true
              this.$router.go(-1)
            }
          })
        } else {
          fromObj.channelResource = '1'
          sell_touristApi.touristAdd(fromObj).then((res) => {
            if (res.code === 200) {
              this.$message.success('新增客源信息成功')
              this.saveType = true
              this.$router.go(-1)
            }
          })
        }
      } else {
        console.log(validateFn1(), validateFn2())
        this.$message.error('未填写完整 ')
      }
    },
    // int验证
    intValidate (fieldName) {
      const val = this.form[fieldName]
      // const reg = /^[0-9]{1,8}$/
      const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
      if (val) {
        const idx = val.indexOf('.')
        // console.log(val,idx, '88', reg, fieldName)
        if (idx > 0) {
          this.form[fieldName] = val
        } else if (idx < 0) {
          if (reg.test(val)) {
            if (!isNaN(val)) {
              this.form[fieldName] = parseInt(val)
            }
          } else {
            this.$message.error('只能输入最多保留两位小数的数字')
            // this.form[fieldName] = ''
          }
        }
      }
      // if (reg.test(val)) {
      //   if (!isNaN(val)) {
      //     this.form[fieldName] = parseInt(val)
      //   }
      // } else {
      //   this.form[fieldName] = ''
      // }
    },
    // 获取行业分类（行业大类）
    industryCategoryFn () {
      const params = {
        industryCategoryType: 1 // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code === 200) {
          this.industryCategory = res.data
        }
      })
    },
    // 获取行业id获取行业名字
    getIndustryCategoryName (val) {
      for (const d of this.industryCategory) {
        if (d.id == val) {
          this.form.industryCategoryName = d.industryCategoryName
          this.industrySubclassFn(val)
        }
      }
    },
    // 获取行业分类（行业小类）
    industrySubclassFn (val) {
      const params = {
        industryCategoryType: 2, // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
        parentId: val
      }
      touristApi.industryCategory(params).then((res) => {
        if (res.code == 200) {
          this.industrySubclass = res.data
        }
      })
    },
    // 获取行业id获取行业名字
    getIndustrySubclassName (val) {
      for (const d of this.industrySubclass) {
        if (d.id == val) {
          this.form.industrySubclassName = d.industryCategoryName
        }
      }
    },

    // 字典表查询
    getDICTS () {
      this.getDicts('payment_type2').then((response) => {
        this.payment_method_list = response.data
        // console.log('付款方式', this.payment_method_list)
      })
      this.getDicts('customer_type').then((response) => {
        this.customer_type_list = response.data
        // console.log('客户类型', this.customer_type_list)
      })
      this.getDicts('investment_type').then((response) => {
        this.investment_type_list = response.data
        // console.log('投资类型', this.investment_type_list)
      })
      this.getDicts('requirement_level').then((response) => {
        this.requirement_level_list = response.data
        // console.log('需求等级', this.requirement_level_list)
      })

      this.getDicts('sys_yes_no').then((response) => {
        this.isOptions = response.data
        // console.log('是否', this.isOptions)
      })
      this.getDicts('sys_user_sex').then((response) => {
        this.sexOptions = response.data
        // console.log(this.sexOptions)
      })

      this.getDicts('shop_nature').then((response) => {
        this.natureOptions = response.data
        // console.log(this.natureOptions)
      })
      this.getDicts('shop_ancillary').then((response) => {
        this.shopAncillaryOpts = response.data
        // console.log(this.shopAncillaryOpts)
      })
      // 消费配套
      this.getDicts('consume_ancillary').then((response) => {
        this.consumeAncillaryOpts = response.data
      })
    }
  },

  created () {
    // this.init()
  },
  activated () {
    const storage = sessionStorage.getItem('history')
    let data = {}
    if (storage) {
      data = JSON.parse(storage)
      if (data.fromPage === 'add') {
        Object.keys(this.form).forEach((el) => {
          if (Array.isArray(this.form[el])) {
            this.form[el] = []
          } else if (Object.prototype.toString.call(this.form[el]) === '[object Object]') {
            this.form[el] = {}
          } else {
            this.form[el] = null
          }
        })
        this.form.lesseeInfoBo = {
          alternatePhone: '', // 备用手机号（最多三个），逗号隔开
          lesseeName: '',
          lesseePhone: '',
          lesseeSex: undefined,
          lesseeWechat: '',
          id: '',
          rentSaleType: '1'
        }
        this.alternatePhone = {
          phone1: '',
          phone2: '',
          phone3: ''
        }
      }
      this.init()
    }
  },
  deactivated () {
    sessionStorage.removeItem('history')
  },
  mounted () {
    // this.getDistrict()
  }
}
</script>

<style lang="less" scoped>
.add {
  height: 100%;
  padding: 20px;
  border-radius: 15px;
  background-color: white;

  .title {
    display: flex;
    align-items: center;

    .name {
      margin-bottom: 0px;
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
  }

  .content {
    padding: 10px 40px;
    margin-bottom: 10px;

    .mr30 {
      margin-right: 30px;
    }

    .label {
      font-size: 18px;
      margin: 20px 0;
    }

    .textarea {
      width: 90%;
      height: 200px;
      outline: none;
      border-radius: 10px;
      border-color: #f1f2f3;
      padding: 10px;
      margin-bottom: 40px;
      resize: none;
      overflow: hidden;
    }

    .label-input {
      label {
        margin-right: 10px;
      }

      input {
        width: 60px;
        border: 1px solid #d9d9d9;
        outline: none;
        height: 16px;
        margin-right: 20px;
      }
    }

    /deep/ .ant-form-item-no-colon {
      color: #666;
      font-size: 16px;
    }
  }

  .el_button {
    background-color: var(--ThemeColor);
    color: white;
    width: 100px;
    height: 40px;

    &:hover {
      color: #fff;
    }
  }
}

.touristBtn:hover {
  color: #fff !important;
}
</style>
